"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var Icon_1 = require("../../Icon");
var BootstrapHelper_1 = require("../../../BootstrapHelper");
var enums_1 = require("../../../enums");
var Input = React.forwardRef(function (_a, ref) {
    var borderStyle = _a.borderStyle, className = _a.className, icon = _a.icon, iconSize = _a.iconSize, iconClass = _a.iconClass, props = __rest(_a, ["borderStyle", "className", "icon", "iconSize", "iconClass"]);
    var cls = (0, BootstrapHelper_1.B)().bl("ui-input");
    var clsMod = (0, BootstrapHelper_1.B)()
        .bl("input")
        .pmod(borderStyle || "").bem;
    var resolvedIconClass = (iconClass === undefined || iconClass === null) ? "" : iconClass;
    return icon ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "ui-input" }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ ref: ref }, props, { name: new Date().getTime().toString() + (Math.random() * 1000000).toFixed(0), className: "".concat(clsMod, " ").concat(className || "") })), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: cls.el("icon").bem + " " + resolvedIconClass, symbol: icon, size: iconSize || enums_1.Enums.UiSizes.MD })] }))) : ((0, jsx_runtime_1.jsx)("input", __assign({ ref: ref }, props, { name: new Date().getTime().toString() + (Math.random() * 1000000).toFixed(0), className: "".concat(clsMod, " ").concat(className || "") })));
});
exports.Input = Input;
